import React from "react";
import heroImg from "../Assests/Image4.jpg";
import qaImg from "../Assests/Image5.jpg";
import harvestImg from "../Assests/Image1.jpg";

const values = [
  { title: "Family-run mill", text: "Founded in 1999, now serving hotels, supermarkets, and wholesalers island-wide." },
  { title: "Quality-first", text: "Every lot is checked for moisture, broken percentage, and cleanliness before packing." },
  { title: "Community focused", text: "Partnering with paddy farmers across Anuradhapura, Polonnaruwa, and Kurunegala." },
  { title: "Sustainable", text: "Husk by-products are repurposed for energy and eco-friendly packaging initiatives." },
];

const milestones = [
  { label: "Years milling", value: "25+" },
  { label: "Retailers supplied", value: "1000+" },
  { label: "Monthly capacity", value: "800T" },
  { label: "Packaging formats", value: "5" },
];

function About() {
  return (
    <div className="page">
      <section className="page-hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="page-hero__content">
          <p className="eyebrow">About Rajarata Rice Mills</p>
          <h1>Born in the heart of Sri Lanka's rice belt</h1>
          <p>
            From a family mill to a modern facility supplying hotels, supermarkets, caterers, and export buyers - we
            keep the craft of milling while embracing technology.
          </p>
          <div className="chip-row">
            <span className="chip">25+ years</span>
            <span className="chip">ISO-inspired hygiene</span>
            <span className="chip">Traceable batches</span>
            <span className="chip">Island-wide delivery</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section__split">
          <div className="card emphasis-card">
            <h3>Our story</h3>
            <p>
              We started with a single milling line serving nearby towns. Today, Rajarata Rice Mills blends deep local
              knowledge with modern cleaning lines, optical sorters, and temperature-controlled storage to deliver
              consistent grains all year.
            </p>
            <p>
              Our team tunes milling parameters for the exact texture, aroma, and polish that Sri Lankan kitchens love -
              from fluffy Samba for lunch plates to aromatic Keeri for biriyani.
            </p>
          </div>
          <div className="image-card">
            <img src={qaImg} alt="Quality team inspecting grain" />
          </div>
        </div>
      </section>

      <section className="section section--tint">
        <div className="section__heading">
          <p className="eyebrow">Our pillars</p>
          <h2>Local expertise, export-grade standards</h2>
          <p className="muted">The values that guide every harvest, milling run, and shipment.</p>
        </div>
        <div className="grid grid--4">
          {values.map((value) => (
            <div className="card step-card" key={value.title}>
              <h4>{value.title}</h4>
              <p>{value.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="dual-panel">
          <div className="card emphasis-card">
            <h3>Certifications & standards</h3>
            <ul className="checklist">
              <li>ISO-inspired hygiene practices for all packing lines.</li>
              <li>Traceable batch coding for export and retail compliance.</li>
              <li>Regular lab checks on moisture, impurities, and grain length.</li>
              <li>Safety training for every plant team member.</li>
            </ul>
          </div>
          <div className="media-blend">
            <img src={harvestImg} alt="Harvest from partner paddy fields" />
            <div className="media-blend__text">Partnering with growers in Anuradhapura & Kurunegala</div>
          </div>
        </div>
      </section>

      <section className="section section--tint">
        <div className="section__heading">
          <p className="eyebrow">By the numbers</p>
          <h2>Capacity, reach, and reliability</h2>
        </div>
        <div className="stat-grid">
          {milestones.map((item) => (
            <div className="stat" key={item.label}>
              <strong>{item.value}</strong>
              <div>{item.label}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;
